import { createContext } from 'react';

import { TypeName } from '@/types';

// Default to most likely use case, Post
const TypeNameContext = createContext<TypeName>('Post');

export default TypeNameContext;
